export default __webpack_public_path__ + "static/study-1-8165742f31cf4edfed0c7f4656e2529a.svg";